export const createSlug = (value: string) => {
  const slug = value.trim().toLowerCase().replace(/#/g, '').split(' ').join('-');
  return slug;
};
